import { Link } from 'react-router-dom';
import { ArrowRight, BookOpen, Pen, Star, Award, CheckCircle } from 'lucide-react';
import SeoHead from '../components/SeoHead';

const PORTFOLIO_ITEMS = [
  { genre: 'Business & Leadership', title: 'From Boardroom to Bestseller', desc: 'A Fortune 500 executive\'s guide to transformative leadership, ghostwritten in 6 weeks.' },
  { genre: 'Memoir', title: 'Threads of Time', desc: 'A family memoir spanning three generations, capturing voices that might otherwise be lost.' },
  { genre: 'Self-Help', title: 'The Morning Blueprint', desc: 'A productivity guide for entrepreneurs, now an Amazon bestseller with 500+ reviews.' },
  { genre: 'Fiction — Thriller', title: 'The Last Cipher', desc: 'A cryptography thriller that hit #1 in its category within the first month.' },
  { genre: 'Children\'s', title: 'Luna\'s Garden', desc: 'An illustrated children\'s book about growing up different — loved by parents and kids alike.' },
  { genre: 'Non-Fiction', title: 'Digital Nomad Blueprint', desc: 'A practical guide to remote work and location independence, with a foreword by a Silicon Valley veteran.' },
];

export default function AffiliatePortfolio() {
  return (
    <>
      <SeoHead title="Our Work — AI Ghostwriter Pro Portfolio" description="See examples of books ghostwritten by AI Ghostwriter Pro. From business books to fiction, memoirs to children's books." />
      <section className="pt-28 pb-20 md:pt-40 md:pb-32">
        <div className="max-w-[1200px] mx-auto px-4 sm:px-6 md:px-12 lg:px-20">
          <div className="text-center mb-16">
            <p className="font-sans uppercase tracking-[0.2em] text-xs font-bold text-primary mb-4">Portfolio</p>
            <h1 className="font-serif text-4xl md:text-5xl tracking-tight mb-4" data-testid="portfolio-title">
              Books We've <span className="text-primary">Brought to Life</span>
            </h1>
            <p className="text-muted-foreground max-w-xl mx-auto">Every book starts as an idea. Here's what happens when you trust professionals to bring yours to the page.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
            {PORTFOLIO_ITEMS.map((item, i) => (
              <div key={i} className="bg-white/5 border border-white/10 rounded-sm p-6 hover:border-primary/30 transition-colors" data-testid={`portfolio-item-${i}`}>
                <p className="text-[10px] font-sans uppercase tracking-[0.2em] text-primary font-bold mb-2">{item.genre}</p>
                <h3 className="font-serif text-lg mb-2">{item.title}</h3>
                <p className="text-xs text-muted-foreground leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>

          <div className="bg-white/5 border border-primary/20 rounded-sm p-8 md:p-12 text-center mb-12">
            <h2 className="font-serif text-2xl md:text-3xl mb-4">Ready to Write <span className="text-primary">Your</span> Book?</h2>
            <p className="text-muted-foreground max-w-lg mx-auto mb-6 text-sm">Join hundreds of authors who turned their ideas into published books. Plans from $149/mo with a 7-day free trial — no credit card required.</p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <Link to="/get-started" data-testid="portfolio-cta" className="inline-flex items-center gap-2 rounded-sm px-8 py-3 bg-primary text-primary-foreground font-semibold text-sm tracking-wide hover:bg-white hover:text-black transition-all shadow-[0_0_15px_rgba(212,175,55,0.3)]">
                Start Free Trial <ArrowRight className="w-4 h-4" />
              </Link>
              <Link to="/pricing" className="inline-flex items-center gap-2 rounded-sm px-8 py-3 border border-white/20 text-foreground font-semibold text-sm tracking-wide hover:border-primary hover:text-primary transition-all">
                View Plans
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
            {[
              { value: '500+', label: 'Books Written' },
              { value: '98%', label: 'Client Satisfaction' },
              { value: '14 days', label: 'Avg. First Draft' },
              { value: '100%', label: 'Copyright Yours' },
            ].map((s, i) => (
              <div key={i} className="p-4">
                <p className="font-serif text-2xl text-primary">{s.value}</p>
                <p className="text-[10px] text-muted-foreground uppercase tracking-wider mt-1">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
